module.exports = __webpack_public_path__ + "img/20_dice[19].428f8f45.png";